import { Box, Flex, Progress, Text } from '@chakra-ui/react';
import UpgradeToPremium from './UpgradeToPremium';

function RatingUsageIndicator({ used = 0, limit = 3, canGenerate = false, isPremium = false, renewalDate = null }) {
    const isUnlimited = isPremium || !Number.isFinite(limit) || limit <= 0;
    const safeLimit = isUnlimited ? null : limit;
    const percent = safeLimit ? Math.min(100, Math.round((used / safeLimit) * 100)) : 0;
    const isAtLimit = !canGenerate && !isPremium;

    const summaryLabel = isPremium
        ? 'Premium member'
        : safeLimit
            ? `${used}/${safeLimit} ratings used this month`
            : `${used} ratings logged`;

    const renewalLabel = renewalDate
        ? new Date(renewalDate).toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        })
        : null;

    return (
        <Box borderWidth="1px" borderRadius="lg" p={4} bg="white" boxShadow="sm" w="100%">
            <Flex justify="space-between" align="center" mb={2} gap={2} flexWrap="wrap">
                <Text fontWeight="bold">AI Rating Usage</Text>
                <Text color={isAtLimit ? 'red.500' : isPremium ? 'green.600' : 'gray.600'} fontSize="sm">
                    {summaryLabel}
                </Text>
            </Flex>
            <Progress.Root value={percent} colorPalette={isAtLimit ? 'red' : 'green'} borderRadius="md" mb={3}>
                <Progress.Track>
                    <Progress.Range />
                </Progress.Track>
            </Progress.Root>
            {isPremium ? (
                <Box bg="green.50" border="1px solid #68d391" borderRadius="md" p={3}>
                    <Text fontWeight="semibold" color="green.700">
                        Premium member: unlimited Buffett ratings
                    </Text>
                    {renewalLabel && (
                        <Text fontSize="sm" color="green.700">
                            Renews {renewalLabel}
                        </Text>
                    )}
                </Box>
            ) : isAtLimit ? (
                <Box bg="yellow.50" border="1px dashed #d69e2e" borderRadius="md" p={3} display="flex" flexDirection="column" gap={2}>
                    <Box>
                        <Text fontWeight="semibold">Monthly limit reached</Text>
                        <Text fontSize="sm" color="gray.700">
                            Upgrade to unlock unlimited Buffett ratings and priority access.
                        </Text>
                    </Box>
                    <UpgradeToPremium />
                </Box>
            ) : (
                <Text fontSize="xs" color="gray.500">
                    {safeLimit ? `Free plan includes ${safeLimit} Buffett ratings per month.` : 'Keep generating Buffett ratings while you still have credits left.'}
                </Text>
            )}
        </Box>
    );
}

export default RatingUsageIndicator;
